<template>
  <DBox
    :id="'dtplugins-dbox-cost'"
    :addButton="false"
    :searchButton="true"
    :searchFlag="searchFlag"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t(
      itemName == 'Cost' ? 'cost' : 'income'
    )}`"
    :badgeButtons="
      filterExists
        ? [
            {
              text: $t('reset_filters'),
              value: 'reset_filters',
              icon: 'delete-white',
            },
          ]
        : []
    "
    @addClick="onAddClick"
    @menuClick="onRightMenuClick"
    @badgeClick="onBadgeClick"
    @searchClick="onSearchClick"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <InputField
          :value="dboxMetaData.str"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            width: '124px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          :options="cost_groupsTV"
          :selected="
            cost_groupsTV.filter(
              (e) =>
                dboxMetaData.selectedCostGroups &&
                dboxMetaData.selectedCostGroups.length > 0 &&
                dboxMetaData.selectedCostGroups.includes(e.value)
            )
          "
          :placeholder="'Select ' + groupName"
          multiple
          allnone
          borderbottom
          v-on:selectedChange="onCostGroupSelected"
          :style="{
            width: '175px',
          }"
        ></Dropdown>
      </div>
      <button @click="fetchListReset" class="dt-button dt-button v5 s8 m8">
        Apply Filter
      </button>
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined,
      }"
    >
      <NTable
        id="dtplugins-dbox_cost-cost_list dbox1"
        ref="dtplugins-dbox_cost-cost_list"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :loadingFlag="dboxMetaData.loadingFlag"
        :items="items"
        :showNoItems="false"
        @scrollnext="onListScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('reporting')">
              <span class="ut-link ut-text-accent5" @click="onEditCost(item)">
                {{ item["date"] }}
              </span>
            </td>
            <td v-bind="tdcon('description')" :title="descriptionText(item)">
              <span class="txtov">
                {{ item["description"] }}
              </span>
            </td>
            <td
              v-bind="tdcon('cost_income_group')"
              :title="item['file_id'] ? '' : 'Upload Documents'"
            >
              <div class="ut-flex">
                <div class="dt-icon-container" style="margin-left: -5px">
                  <img
                    @click.stop="(e) => onUploadFile(item)"
                    :src="
                      item['file_id']
                        ? 'static/icons/cloud-fill.svg'
                        : 'static/icons/cloud.svg'
                    "
                    class="dt-icon v5 s2"
                  />
                </div>
                <span @click.stop="(e) => onUploadFile(item)">
                  <!-- {{ item["cost_group_name"] }} -->
                  {{ cost_income_groupText(item) }}
                </span>
              </div>
            </td>
            <td v-bind="tdcon('ignore')">
              <div
                v-if="!item.recoupable_txt.includes('Accounted')"
                class="ut-rowcen"
              >
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`exclude-${item['hold_flag']}`"
                    :id="`exclude-${item['hold_flag']}`"
                    :checked="item['hold_flag'] == '1'"
                    @click="(e) => onHold(e, item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>

            <td v-bind="tdcon('amount_iso')" :title="amount_isoText(item)">
              <span class="ut-jend txtov">
                {{ $dft.curr(item["amount_orig_curr"]) }}
                {{ item["currency"] }}
                <!-- {{ item["hold_flag"] }} -->
              </span>
            </td>
            <td v-bind="tdcon('amount_eur')" :title="amount_eurText(item)">
              <span class="ut-jen txtov">
                {{ $dft.curr(item["amount"]) }}
                {{ $store.getters.account.client.default_currency }}
              </span>
            </td>
            <td v-bind="tdcon('recoupment')" :title="recoupStatus(item)">
              <div class="ut-jend">
                <span class="txtov">
                  {{ recoupStatus(item) }}
                </span>
                <div class="dt-icon-container">
                  <img
                    @click.stop="(e) => onRecoupStatusClick(item)"
                    :src="
                      recoupStatus(item) != 'Do not Recoup'
                        ? 'static/icons/finance/finance-blue.svg'
                        : 'static/icons/finance/finance.svg'
                    "
                    class="dt-icon v5 s1"
                  />
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <div
                v-if="!item.recoupable_txt.includes('Accounted')"
                class="dt-icon-container"
              >
                <img
                  @click.stop="(e) => deleteCost(item)"
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>

      <template v-if="isCost">
        <template v-if="costFormModalContainer">
          <v-dialog v-model="costFormModal" persistent width="390">
            <DBoxCostForm
              :itemName="itemName"
              :groupName="groupName"
              :config="storeConfig"
              :cost_groupsTV="cost_groupsTV"
              @added="onSubmittedCost"
              @edited="onSubmittedCost"
              @cancelled="onModalCancelled"
            />
          </v-dialog>
        </template>
        <template v-if="costOpenAdvanceModalContainer">
          <v-dialog v-model="costOpenAdvanceModal" persistent width="390">
            <DBoxCostOpenAdvance
              :itemName="itemName"
              :config="storeConfig"
              @advance_made="onAdvanceMade"
              @cancelled="onModalCancelled"
            />
          </v-dialog>
        </template>
        <template v-if="costRecoupablesModalContainer">
          <v-dialog v-model="costRecoupablesModal" persistent width="928">
            <DBoxCostRecoupables
              :status="'cost'"
              :config="storeConfig"
              @advance_made="onAdvanceMade"
              @cancelled="onRecoupablesCancel"
            />
          </v-dialog>
        </template>
        <template v-if="costFileModalContainer">
          <v-dialog v-model="costFileModal" persistent width="390">
            <DBoxCostFile
              :itemName="itemName"
              :item="items.find((e) => e.cost_split_id == selectedCostSplitId)"
              @uploaded="dBoxCostFileUploaded"
              @cancelled="onModalCancelled"
            />
          </v-dialog>
        </template>
      </template>

      <template v-if="isOtherIncome">
        <template v-if="otherIncomeFormModalContainer">
          <v-dialog v-model="otherIncomeFormModal" persistent width="390">
            <DBoxCostForm
              :itemName="itemName"
              :config="storeConfig"
              :groupName="groupName"
              :cost_groupsTV="cost_groupsTV"
              @added="onSubmittedCost"
              @edited="onSubmittedCost"
              @cancelled="onModalCancelled"
            />
          </v-dialog>
        </template>
        <template v-if="otherIncomeOpenAdvanceModalContainer">
          <v-dialog
            v-model="otherIncomeOpenAdvanceModal"
            persistent
            width="390"
          >
            <DBoxCostOpenAdvance
              :itemName="itemName"
              :config="storeConfig"
              @advance_made="onAdvanceMade"
              @cancelled="onModalCancelled"
            />
          </v-dialog>
        </template>

        <template v-if="otherIncomeRecoupablesModalContainer">
          <v-dialog
            v-model="otherIncomeRecoupablesModal"
            persistent
            width="800"
          >
            <DBoxCostRecoupables
              :status="'cost'"
              :config="storeConfig"
              @advance_made="onAdvanceMade"
              @cancelled="onRecoupablesCancel"
            />
          </v-dialog>
        </template>
        <template v-if="otherIncomeFileModalContainer">
          <v-dialog v-model="otherIncomeFileModal" persistent width="390">
            <DBoxCostFile
              :itemName="itemName"
              :item="items.find((e) => e.cost_split_id == selectedCostSplitId)"
              @uploaded="dBoxCostFileUploaded"
              @cancelled="onModalCancelled"
            />
          </v-dialog>
        </template>
      </template>
    </div>
  </DBox>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import DBoxCostForm from "./dbox-costs-form";
import DBoxCostOpenAdvance from "./dbox-costs-open-advance";
import DBoxCostRecoupables from "./dbox-costs-recoupables";
import DBoxCostFile from "./dbox-costs-upload-file.vue";

import { createNTableConfig, createTableHeader } from "../../plugins/datatable";
import InputField from "@plugins/text-field/input-field";
import { createTV } from "../../models/text-value.model";
import { DBoxCostService } from "./dbox-costs.service";
import {
  closeModalRoute,
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../modal/modal.mixin";
import { confirmDelete } from "../confirmation/confirmation-common";
import { isEmpty } from "ramda";
import { useDBoxStore } from "../dboxstore/dboxstore.mixin";
import { subscribeSubjectND, toSnakeCase } from "../../utility";
import { Subject } from "rxjs";
import { EOL_REACHED } from "../advanced-search/load.model";

export default {
  components: {
    Modal,
    NTable,
    InputField,
    ModalContainer,
    DBoxCostForm,
    DBoxCostOpenAdvance,
    DBoxCostRecoupables,
    DBoxCostFile,
  },
  props: {
    cost_groups: {
      type: Array,
      required: true,
    },
    storeConfig: {
      type: Object,
      required: true,
    },
    // storeNamesPace: {
    //   type: String,
    //   required: true,
    // },
    // detailsActionString: {
    //   type: String,
    //   required: true,
    // },
    // detailsGetterKey: {
    //   type: String,
    //   required: true,
    // },
    // itemsKey: {
    //   type: String,
    //   required: true,
    // },
    // primaryKeyValue: {
    //   type: String,
    //   required: true,
    // },
  },
  mounted() {
    // Settings All DBOx Metadata

    // At First mounted Call dboxPluginStore is undefined
    if (this.dboxPluginStore) {
      this.dboxPluginStore.updateDBoxStoreState(
        (e) => e,
        (metadata) => {
          return {
            ...metadata,
            selectedCostGroups: [],
            str: "",
            start: 0,
            row_count: 100,
            loadedStart: 0,
            loadingFlag: false,
            eol_flag: false,
          };
        }
      );
    }
    console.warn({ "dbox-costs.vue:139 mounted": this.dboxMetadata });

    subscribeSubjectND(this, this.scrollSubject, (scrollTop) => {
      if (this.dboxMetaData.start == this.dboxMetaData.loadedStart) {
        this.dboxPluginStore.updateDBoxStoreState(
          (e) => e,
          (metadata) => {
            console.log({ metadata });
            return {
              ...metadata,
              start: (metadata?.start || 0) + (metadata?.row_count || 0),
            };
          }
        );
        console.log(this.dboxMetaData.start, this.dboxMetaData.loadedStart);
        this.fetchListNext();
      }
    });
  },
  data() {
    return {
      scrollSubject: new Subject(),

      searchFlag: false,

      selectedCostGroup: null,

      tableHeight: `236px`,

      // DPSCreator: null,

      selectedCostItem: null,
    };
  },
  mixins: [
    useDBoxStore(),

    createModalMixin("costForm"),
    createModalMixin("otherIncomeForm"),
    createModalMixin("costOpenAdvance"),
    createModalMixin("costRecoupables"),
    createModalMixin("otherIncomeOpenAdvance"),
    createModalMixin("otherIncomeRecoupables"),
    createModalMixin("costFile"),
    createModalMixin("otherIncomeFile"),
  ],
  // beforeMount: async function () {
  //   this.DPSCreator = createDBoxPluginStore(this.$store);
  // },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        headerStyle: 3,
      });
    },
    headers: function () {
      return [
        createTableHeader("reporting", { f: 0.952 }),
        createTableHeader("description", { f: 2.505 }),
        createTableHeader("cost_income_group", {
          f: 1.4,
          text: `${
            this.groupName == "Cost Group" ? "costgroup" : "income_group"
          }`,
        }),
        createTableHeader("ignore", { f: 0.631 }),
        createTableHeader("amount_iso", {
          f: 1.262,
          ta: "right",
          text: this.$t("amount") + " ISO",
        }),
        createTableHeader("amount_eur", {
          f: 1.262,
          ta: "right",
          text: `${this.$t("amount")} ${
            this.$store.getters.account.client.default_currency
          }`,
        }),
        createTableHeader("recoupment", {
          f: 1.472,
          ta: "right",
        }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    // dboxPluginStore() {
    //   return this.DPSCreator(this.storeConfig);
    // },
    dboxMetaData() {
      return (
        this.dboxPluginStore?.dboxMetaData || {
          selectedCostGroups: [],
          str: "",

          start: 0,
          row_count: 100,
          loadedStart: 0,
          loadingFlag: false,
          eol_flag: false,
        }
      );
    },
    filterExists() {
      return (
        this.dboxMetaData.str ||
        (this.dboxMetaData.selectedCostGroups &&
          this.dboxMetaData.selectedCostGroups.length > 0)
      );
    },
    costModalKey() {
      return `costForm`;
    },
    costModalRouteKey() {
      return toSnakeCase(this.costModalKey);
    },
    otherIncomeModalKey() {
      return `otherIncomeForm`;
    },
    otherIncomeModalRouteKey() {
      return toSnakeCase(this.otherIncomeModalKey);
    },
    items() {
      return this.dboxPluginStore?.dboxData || [];
    },
    itemName() {
      return this.storeConfig.dataKey == "costs" ? "Cost" : "Other Income";
    },
    groupName() {
      return this.storeConfig.dataKey == "costs"
        ? "Cost Group"
        : "Income Group";
    },
    isCost() {
      return this.storeConfig.dataKey == "costs";
    },
    isOtherIncome() {
      return this.storeConfig.dataKey != "costs";
    },
    cost_groupsTV() {
      // console.log({ "this.cost_groups": this.cost_groups });
      return createTV(
        this.isCost
          ? this.cost_groups.filter((e) => e.income_flag != 1)
          : this.cost_groups.filter((e) => e.income_flag == 1),
        "cost_group_name",
        "cost_group_id"
      );
    },
    selectedCostSplitId() {
      return this.$route.query.cost_split_id;
    },
  },
  methods: {
    onRightMenuClick: function (menu) {},
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit("showSearchFlag", this.searchFlag);
    },
    onSearchInputKeyup: function (event) {
      const value = event.target.value;
      this.dboxPluginStore.updateDBoxStoreState(
        (e) => e,
        (metadata) => {
          console.log({ metadata: metadata });
          return {
            ...metadata,
            str: value,
          };
        }
      );
    },
    onCostGroupSelected: async function (value) {
      console.log(value);

      this.dboxPluginStore.updateDBoxStoreState(
        (e) => e,
        (metadata) => {
          return {
            ...metadata,
            selectedCostGroups: value?.map((e) => e.value) ?? [],
          };
        }
      );
    },
    onHold: async function (e, item) {
      const hold_flag = e.target.checked ? `checked` : "unchecked";

      const { cost_split_id } = item;

      // const nsGetter = `${this.storeConfig.storeNamesPace}/${this.storeConfig.detailsGetterKey}`;
      // const detailsDict = this.$store.getters[nsGetter];
      // const selectedDetails =
      //   detailsDict[this.storeConfig.primaryKeyValue];

      const recoupable_txt = await DBoxCostService.updateCostHoldFlag(
        cost_split_id,
        hold_flag
      );
      const hold_flag_value = hold_flag == "checked" ? 1 : null;

      this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
        return dboxData.map((e) => {
          if (e.cost_split_id == cost_split_id) {
            return {
              ...e,
              hold_flag: hold_flag_value,
              recoupable_txt: recoupable_txt.data.recoupable_txt,
            };
          } else {
            return e;
          }
        });
      });
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        console.log({ badge: badge });
        this.dboxPluginStore.updateDBoxStoreState(
          (e) => e,
          (metadata) => {
            return {
              selectedCostGroups: [],
              str: "",
            };
          }
        );
        this.fetchListReset();
        this.searchFlag = false;
        this.$emit("showSearchFlag", this.searchFlag);
      }
    },
    onAddClick() {
      if (this.isCost) {
        openModalRoute(this, this.costModalRouteKey, {
          mode: "add",
        });
      } else {
        openModalRoute(this, this.otherIncomeModalRouteKey, {
          mode: "add",
        });
      }
    },
    onEditCost({ cost_split_id }) {
      console.log(this.isCost);
      if (this.isCost) {
        openModalRoute(this, this.costModalRouteKey, {
          mode: "edit",
          cost_split_id,
        });
      } else {
        openModalRoute(this, this.otherIncomeModalRouteKey, {
          mode: "edit",
          cost_split_id,
        });
      }
    },
    onModalCancelled() {
      closeModalRoute(this, {
        mode: undefined,
        cost_split_id: undefined,
      });
    },
    async onSubmittedCost(payload) {
      console.log(this.costData(payload));
      const addedCost = await DBoxCostService.saveCost({
        costData: this.costData(payload),
        external_table: this.storeConfig.externalTable,
        external_id: this.storeConfig.primaryKeyValue,
      });
      this.dboxPluginStore.updateDBoxStoreState(
        (dboxData) => addedCost.data.costs
      );
      console.log({ addedCost: addedCost });
      const { release_costs_total, product_costs_total } = addedCost.data;
      this.$emit("updated", { release_costs_total, product_costs_total });
      this.onModalCancelled();
    },

    costData(payload) {
      console.log({
        pj: payload.json_data,
        "isEmpty(payload.json_data": isEmpty(payload.json_data),
      });
      let cd = {
        ...payload,
        ...(payload.json_data && !isEmpty(payload.json_data)
          ? { json_data_str: JSON.stringify(payload.json_data) }
          : {}),
      };
      delete cd.json_data;
      return cd;
    },
    async deleteCost({ cost_split_id, description }) {
      const deleteResult = await confirmDelete(this.itemName, description);
      if (deleteResult == "OK") {
        this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
          return dboxData.filter((e) => e.cost_split_id != cost_split_id);
        });

        await DBoxCostService.deleteCost(cost_split_id);
      }
    },
    async onRecoupStatusClick(item) {
      console.log(item, item["recoupable_txt"]);
      const { cost_split_id, recoupable_txt: status } = item;

      switch (status) {
        case "Open Advance": {
          console.log({ costOpenAdvance: 1 });
          if (this.isCost) {
            openModalRoute2(this, "costOpenAdvance", {
              cost_split_id,
            });
          } else {
            openModalRoute2(this, "otherIncomeOpenAdvance", {
              cost_split_id,
            });
          }
          break;
        }
        case "Not Recoupable": {
          if (this.isCost) {
            openModalRoute2(this, "costRecoupables", {
              cost_split_id,
            });
          } else {
            openModalRoute2(this, "otherIncomeRecoupables", {
              cost_split_id,
            });
          }
          break;
        }
        case "Do not Recoup": {
          break;
        }
        case "Account Recoupables": {
          const createdAccountRecoupable =
            await DBoxCostService.createCostSplit({
              cost_split_id,
            });
          const { recoupable_txt } = createdAccountRecoupable.data;

          this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
            return dboxData.map((e) => {
              if (e.cost_split_id == cost_split_id) {
                return {
                  ...e,
                  recoupable_txt,
                };
              } else {
                return e;
              }
            });
          });
          break;
        }
        default: {
          // If Recoup Status is Accounted
          if (status.startsWith("Accounted:")) {
            if (this.isCost) {
              openModalRoute2(this, "costRecoupables", {
                cost_split_id,
              });
            } else {
              openModalRoute2(this, "otherIncomeRecoupables", {
                cost_split_id,
              });
            }
          } else {
          }
        }
      }
    },
    recoupStatus(item) {
      const status = item["recoupable_txt"] || "";
      if (status.startsWith("Accounted:")) {
        return status.slice(11);
      } else {
        return status;
      }
    },
    onAdvanceMade({ recoupable_txt, cost_split_id }) {
      this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
        return dboxData.map((e) => {
          if (e.cost_split_id == cost_split_id) {
            return {
              ...e,
              recoupable_txt,
            };
          } else {
            return e;
          }
        });
      });
      this.onModalCancelled();
    },
    async onRecoupablesCancel(cost_split_id) {
      if (cost_split_id) {
        const recoupableRes = await DBoxCostService.getRecoupableStatus({
          cost_split_id,
        });
        const recoupable_txt = recoupableRes?.data?.recoupable_txt;

        this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
          return dboxData.map((e) => {
            if (e.cost_split_id == cost_split_id) {
              return {
                ...e,
                recoupable_txt,
              };
            } else {
              return e;
            }
          });
        });
      }
      this.onModalCancelled();
    },
    onUploadFile(item) {
      const { cost_split_id } = item;
      if (this.isCost) {
        openModalRoute2(this, "costFile", {
          cost_split_id,
        });
      } else {
        openModalRoute2(this, "otherIncomeFile", {
          cost_split_id,
        });
      }
    },
    dBoxCostFileUploaded(filedone) {
      const { done, file_id } = filedone;
      console.log(filedone);
      if (done == 1) {
        this.dboxPluginStore.updateDBoxStoreState((dboxData) => {
          return dboxData.map((e) => {
            if (e.cost_split_id == this.selectedCostSplitId) {
              return {
                ...e,
                file_id: file_id,
              };
            } else {
              return e;
            }
          });
        });
      }

      this.onModalCancelled();
    },
    descriptionText(item) {
      return `${item["description"]}`;
    },
    cost_income_groupText(item) {
      if (item?.["cost_group_name"]) {
        return `${item["cost_group_name"]}`;
      } else if (item?.["cost_group_id"]) {
        return this.cost_groupsTV?.find(
          (e) => e.value == item?.["cost_group_id"]
        )?.text;
      } else {
        return ``;
      }
    },
    amount_isoText(item) {
      return `${this.$dft.curr(item["amount_orig_curr"])} ${item["currency"]}`;
    },
    amount_eurText(item) {
      return `${this.$dft.curr(item["amount"])} ${item["currency"]}`;
    },
    async onListScroll(value) {
      console.log({ "dbox-costs.vue:824 onScrollNext": 1 });
      this.scrollSubject.next(value);
    },
    async fetchListAction() {
      const costs = await DBoxCostService.fetch({
        external_table: this.storeConfig.externalTable,
        external_id: this.storeConfig.primaryKeyValue,

        str: this?.dboxPluginStore?.dboxMetaData?.str,
        cost_groups: `[${
          this.dboxMetaData?.selectedCostGroups?.map((e) => `"${e}"`)?.join() ??
          ""
        }]`,

        start: this.dboxMetaData.start,
        row_count: this.dboxMetaData.row_count,
      });

      if (this.dboxMetaData.start == 0) {
        this.dboxPluginStore.updateDBoxStoreState(
          (dboxData) => costs.data.costs
        );
      } else {
        this.dboxPluginStore.updateDBoxStoreState((dboxData) => [
          ...dboxData,
          ...costs.data.costs,
        ]);

        // Setting EOL
        if (!(costs?.data?.costs?.length > 0)) {
          return EOL_REACHED;
        }
      }
    },
    fetchListNext: async function () {
      console.log({ "dbox-costs.vue:852 fetchListNext": 1 });
      await this.fetchList();
      // this.loadedStart = this.start;
      this.dboxPluginStore.updateDBoxStoreState(
        (e) => e,
        (metadata) => {
          return {
            ...metadata,
            loadedStart: metadata.start,
          };
        }
      );
    },
    fetchList: async function () {
      console.log({
        "dbox-costs.vue:885 this.dboxMetaData": this.dboxMetaData,
      });
      if (this.dboxMetaData.eol_flag === false) {
        // this.loadingFlag = true;
        this.dboxPluginStore.updateDBoxStoreState(
          (e) => e,
          (metadata) => {
            return {
              ...metadata,
              loadingFlag: true,
            };
          }
        );

        const loadStatus = await this.fetchListAction();

        if (loadStatus === EOL_REACHED) {
          // this.eol_flag = true;
          this.dboxPluginStore.updateDBoxStoreState(
            (e) => e,
            (metadata) => {
              return {
                ...metadata,
                eol_flag: true,
              };
            }
          );
        }
        // this.loadingFlag = false;
        this.dboxPluginStore.updateDBoxStoreState(
          (e) => e,
          (metadata) => {
            return {
              ...metadata,
              loadingFlag: false,
            };
          }
        );
      }
    },
    fetchListReset: async function () {
      // this.start = 0;
      // this.loadedStart = 0;
      // this.eol_flag = false;

      this.dboxPluginStore.updateDBoxStoreState(
        (e) => e,
        (metadata) => {
          return {
            ...metadata,
            start: 0,
            loadedStart: 0,
            eol_flag: false,
          };
        }
      );

      // Reset the Scroll Position
      this.$refs["dtplugins-dbox_cost-cost_list"].resetScroll();
      await this.fetchList();
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dtplugins-dbox-cost {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
    .dropdown {
      margin: 10px;
    }
  }
}
</style>